import { CustomerFormModel, CustomerShort } from "@app/companyTab/@types/Customer";
import { UpdateCustomer } from "./customers";
import { axiosInstanceCustomers } from "./customersAxiosInstance";
import { FormConfig } from "types/form";

export const CustomerController = Object.freeze({
  getCustomers: () => axiosInstanceCustomers.get<CustomerShort[]>(`/customer`),
  createCustomer: (data: { inn: string }) =>
    axiosInstanceCustomers.post<CustomerShort>("/customer", data),
  updateCustomer: ({ orderId, components }: UpdateCustomer) =>
    axiosInstanceCustomers.post(`/card/customer/${orderId}/model`, { components }),
  getConfig: (companyId: string) =>
    axiosInstanceCustomers.get<FormConfig>(`/card/customer/${companyId}/config`),
  getModel: (companyId: string) =>
    axiosInstanceCustomers.get<CustomerFormModel>(`/card/customer/${companyId}/model`),
  searchPerson: (q: string) => axiosInstanceCustomers.get(`/person?q=${q}`),
});
